import i18n from "../../../../../i18n";

export const addressSelectionModalInfo = [
  { name: "street", label: i18n.t("Street"), placeholder: i18n.t("Enter street name"), required: true },
  {
    name: "house",
    label: i18n.t("House number"),
    placeholder: i18n.t("House number input placeholder"),
    required: true,
  },
  {
    placeholder: i18n.t("Apartment input placeholder"),
    label: i18n.t("Apartment"),
    name: "apartmentNumber",
    required: false,
  },
  { name: "entrance", label: i18n.t("Entrance"), placeholder: i18n.t("Entrance input placeholder"), required: false },
  { name: "floor", label: i18n.t("Floor"), placeholder: i18n.t("Floor input placeholder"), required: false },
  {
    name: "intercom",
    label: i18n.t("Intercom code"),
    placeholder: i18n.t("Intercom input placeholder"),
    required: false,
  },
];
